export default {"src":"/_next/static/media/Cagliari.ae108409.svg","height":300,"width":248,"blurWidth":0,"blurHeight":0};